__turbopack_context__.v({
  "closeButton": "VhSYtG_closeButton",
  "hero-nav-pulse": "VhSYtG_hero-nav-pulse",
  "heroCarousel": "VhSYtG_heroCarousel",
  "playOverlay": "VhSYtG_playOverlay",
  "videoFloatingContainer": "VhSYtG_videoFloatingContainer",
  "videoOverlay": "VhSYtG_videoOverlay",
});
